module.exports = __webpack_public_path__ + "static/img/16.67151bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/temp/16.jpg
// module id = FoLH
// module chunks = 36